<template>
  <div class="bg-white-wrapper">
    <div class="container">
      <!-- <div class="product-search-selected">
        <span class="product-search-icon">
          <Icon type="ios-funnel" />
        </span>
        <span class="product-search-text">所选条件 ></span>
        <template v-if="menuId>0">
          <router-link :to="{name:'ProductDiyList',query:{c:0,l:0,m:0,t:typeId,s:specialId},params:{id:menuId}}" v-if="categoryId>0">
            {{currentQueryName("c")}}
            <Icon type="md-close" />
          </router-link>
          <router-link :to="{name:'ProductDiyList',query:{c:categoryId,l:0,m:0,t:typeId,s:specialId},params:{id:menuId}}" v-if="labelId>0">
            {{currentQueryName("l")}}
            <Icon type="md-close" />
          </router-link>
          <router-link :to="{name:'ProductDiyList',query:{c:categoryId,l:labelId,m:0,t:typeId,s:specialId},params:{id:menuId}}" v-if="majorId>0">
            {{currentQueryName("m")}}
            <Icon type="md-close" />
          </router-link>
        </template>
        <template v-else>
          <router-link :to="{name:'ProductList',query:{c:0,l:0,m:0,t:typeId,s:specialId}}" v-if="categoryId>0">
            {{currentQueryName("c")}}
            <Icon type="md-close" />
          </router-link>
          <router-link :to="{name:'ProductList',query:{c:categoryId,l:0,m:0,t:typeId,s:specialId}}" v-if="labelId>0">
            {{currentQueryName("l")}}
            <Icon type="md-close" />
          </router-link>
          <router-link :to="{name:'ProductList',query:{c:categoryId,l:labelId,m:0,t:typeId,s:specialId}}" v-if="majorId>0">
            {{currentQueryName("m")}}
            <Icon type="md-close" />
            <router-link :to="{name:'ProductList',query:{c:categoryId,l:labelId,m:majorId,t:0,s:0}}" v-if="typeId>0">
              {{currentQueryName("t")}}
              <Icon type="md-close" />
            </router-link>
            <router-link :to="{name:'ProductList',query:{c:categoryId,l:labelId,m:majorId,t:typeId,s:0}}" v-if="specialId>0">
              {{currentQueryName("s")}}
              <Icon type="md-close" />
            </router-link>
            <router-link :to="{name:'ProductList',query:{c:categoryId,l:labelId,m:majorId,t:typeId,s:specialId}}" v-if="keywords && keywords!=''">
              {{keywords}}
              <Icon type="md-close" />
            </router-link>
          </router-link>
        </template>
      </div> -->
      <template v-if="menuId > 0">
        <!-- 类别 -->
        <div class="product-search-letter">
          <div class="search-filter">
            <span>类别：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductDiyList',
                  query: {
                    c: 0,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                  params: { id: menuId },
                }"
                :class="{ selected: categoryId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in categoryList"
                :key="index"
                :class="{ selected: item.id == categoryId }"
                :to="{
                  name: 'ProductDiyList',
                  query: {
                    c: item.id,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                  params: { id: menuId },
                }"
                >{{ item.name }}</router-link
              >
            </div>
          </div>
        </div>
        <!-- 标签（xx类） -->
        <div class="product-search-letter" v-show="categoryId > 0">
          <div class="search-filter">
            <span>类型：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductDiyList',
                  query: {
                    c: categoryId,
                    l: 0,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                  params: { id: menuId },
                }"
                :class="{ selected: labelId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in labelList"
                :key="index"
                :class="{ selected: item.id == labelId }"
                :to="{
                  name: 'ProductDiyList',
                  query: {
                    c: categoryId,
                    l: item.id,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                  params: { id: menuId },
                }"
                >{{ item.lableName }}</router-link
              >
            </div>
          </div>
        </div>
        <!-- 专业 -->
        <div class="product-search-letter" v-show="labelId > 0">
          <div class="search-filter">
            <span>专业：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductDiyList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: 0,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                  params: { id: menuId },
                }"
                :class="{ selected: majorId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in majorList"
                :key="index"
                :class="{ selected: item.majorid == majorId }"
                :to="{
                  name: 'ProductDiyList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: item.majorid,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                  params: { id: menuId },
                }"
                >{{ item.majorname }}</router-link
              >
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- 类别 -->
        <div class="product-search-letter">
          <div class="search-filter">
            <span>类别：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductList',
                  query: {
                    c: 0,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                }"
                :class="{ selected: categoryId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in categoryList"
                :key="index"
                :class="{ selected: item.id == categoryId }"
                :to="{
                  name: 'ProductList',
                  query: {
                    c: item.id,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                }"
                >{{ item.name }}</router-link
              >
            </div>
          </div>
        </div>
        <!-- 标签（xx类） -->
        <div class="product-search-letter" v-show="categoryId > 0">
          <div class="search-filter">
            <span>类型：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: 0,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                }"
                :class="{ selected: labelId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in labelList"
                :key="index"
                :class="{ selected: item.id == labelId }"
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: item.id,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                }"
                >{{ item.lableName }}</router-link
              >
            </div>
          </div>
        </div>
        <!-- 专业 -->
        <div class="product-search-letter" v-show="labelId > 0">
          <div class="search-filter">
            <span>专业：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: 0,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                }"
                :class="{ selected: majorId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in majorList"
                :key="index"
                :class="{ selected: item.majorid == majorId }"
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: item.majorid,
                    t: typeId,
                    s: specialId,
                    a: addressId,
                    k: keywords,
                  },
                }"
                >{{ item.majorname }}</router-link
              >
            </div>
          </div>
        </div>
        <!-- 类型 -->
        <div class="product-search-letter">
          <div class="search-filter">
            <span>班别：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: majorId,
                    t: 0,
                    a: addressId,
                    k: keywords,
                  },
                }"
                :class="{ selected: typeId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in typeList"
                :key="index"
                :class="{ selected: item.id == typeId }"
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: majorId,
                    t: item.id,
                    a: addressId,
                    k: keywords,
                  },
                }"
                >{{ item.name }}</router-link
              >
            </div>
          </div>
        </div>
        <!-- 班型 -->
        <div class="product-search-letter" v-show="typeId > 0">
          <div class="search-filter">
            <span>班型：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: majorId,
                    t: typeId,
                    s: 0,
                    a: addressId,
                    k: keywords,
                  },
                }"
                :class="{ selected: specialId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in specialList"
                :key="index"
                :class="{ selected: item.id == specialId }"
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: majorId,
                    t: typeId,
                    s: item.id,
                    a: addressId,
                    k: keywords,
                  },
                }"
                >{{ item.name }}</router-link
              >
            </div>
          </div>
        </div>
        <!-- 地址 -->
        <div class="product-search-letter">
          <div class="search-filter">
            <span>地区：</span>
            <div class="sultan-box">
              <router-link
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: majorId,
                    t: typeId,
                    s: specialId,
                    a: 0,
                    k: keywords,
                  },
                }"
                :class="{ selected: addressId == 0 }"
                >All</router-link
              >
              <router-link
                v-for="(item, index) in addressList"
                :key="index"
                :class="{ selected: item.code == addressId }"
                :to="{
                  name: 'ProductList',
                  query: {
                    c: categoryId,
                    l: labelId,
                    m: majorId,
                    t: typeId,
                    s: specialId,
                    a: item.code,
                    k: keywords,
                  },
                }"
                >{{ item.name }}</router-link
              >
            </div>
          </div>
        </div>
      </template>

      <!-- <div class="product-search-count">共查询到{{ productCount }}门课程</div> -->
    </div>
  </div>
</template>

<script>
/** 路由参数
 * c  categoryId 类别Id
 * l  labelId 标签Id（专业类型）
 * m  majorId 专业Id
 * t  typeId 类型Id（单科，套餐）
 * s  specialId 班型
 * k  keywords 关键字
 */
import { siteMixin } from '../../utils/mixin';
import { mall } from '../../request';
export default {
  mixins: [siteMixin],
  props: {
    productCount: {
      type: Number,
      default: 0,
    },
    menuId: {
      type: Number,
      default: 0,
    },
    searchParams: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      categoryId: 0,
      categoryList: [],
      labelId: 0,
      labelList: [],
      majorId: 0,
      majorList: [],
      typeId: 0,
      typeList: [],
      specialId: 0,
      specialList: [],
      keywords: '',
      addressList: [],
      addressId: 0,
    };
  },
  watch: {
    $route(to, from) {
      // console.log('SearchFilter-watch',this.searchParams);
      this.changeQueryValue(to, from);

      // this.addressId =this.addressIdParent;
      for (var key in this.searchParams) {
        if (this.searchParams[key]) {
          console.log('已存在' + key);
          this[key] = this.searchParams[key];
        }
      }
    },
  },
  mounted() {
    this.initQueryValue();
  },
  methods: {
    initQueryValue() {
      this.categoryId = this.$route.query.c ?? 0;
      this.labelId = this.$route.query.l ?? 0;
      this.majorId = this.$route.query.m ?? 0;
      this.typeId = this.$route.query.t ?? 0;
      this.specialId = this.$route.query.s ?? 0;
      this.keywords = this.$route.query.k ?? '';
      this.addressId = this.$route.query.a ?? 0;
      this.getFilterList();
      this.getAddress();
    },
    getAddress() {
      mall.getAddress(this.siteConfig.agencyId).then(res => {
        if (res.status === 1) {
          this.addressList = res.data;
        }
      });
    },
    getFilterList() {
      mall
        .getFilterList({
          agencyId: this.siteConfig.agencyId,
          typeId: this.categoryId,
          labelId: this.labelId,
          specialId: this.typeId,
          specialTypeId: this.specialId,
        })
        .then(res => {
          //console.log(res);
          if (res.status === 1) {
            this.categoryList = res.data.dmTypes;
            this.labelList = res.data.dmLables;
            this.majorList = res.data.majors;
            this.typeList = res.data.specialTypeParents;
            this.specialList = res.data.dmSpecialTypes;
          }
        });
    },
    changeQueryValue(to, from) {
      if (to.query.c !== from.query.c) {
        this.categoryId = to.query.c ?? 0;
      }
      if (to.query.l !== from.query.l) {
        this.labelId = to.query.l ?? 0;
      }
      if (to.query.m !== from.query.m) {
        this.majorId = to.query.m ?? 0;
      }
      if (to.query.t !== from.query.t) {
        this.typeId = to.query.t ?? 0;
      }
      if (to.query.s !== from.query.s) {
        this.specialId = to.query.s ?? 0;
      }
      if (to.query.k !== from.query.k) {
        this.keywords = to.query.k ?? '';
      }
      // if (!to.query?.k) {
      if (to.query.a !== from.query.a) {
        this.addressId = to.query.a ?? 0;
      }
      // }
      this.getFilterList();
    },
    currentQueryName(queryType) {
      switch (queryType) {
        case 'c': {
          let result = this.categoryList.filter(
            item => item.id == this.categoryId,
          )[0];
          if (result) return result.name;
          return '';
        }
        case 'l': {
          let result = this.labelList.filter(
            item => item.id == this.labelId,
          )[0];
          if (result) return result.lableName;
          return '';
        }
        case 'm': {
          let result = this.majorList.filter(
            item => item.majorid == this.majorId,
          )[0];
          if (result) return result.majorname;
          return '';
        }
        case 't': {
          let result = this.typeList.filter(item => item.id == this.typeId)[0];
          if (result) return result.name;
          return '';
        }
        case 's': {
          let result = this.specialList.filter(
            item => item.id == this.specialId,
          )[0];
          if (result) return result.name;
          return '';
        }
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';
// .product-search-selected {
//   padding: 10px 0;
//   border-bottom: 1px solid #dfdfdf;
//   color: #787878;
//   .product-search-icon {
//     margin-right: 5px;
//   }
//   .product-search-text {
//     margin-right: 3px;
//   }
//   a {
//     padding: 1px 5px;
//     border: 1px solid #dfdfdf;
//     display: inline-block;
//     text-align: center;
//     margin-right: 5px;
//     color: #666666;
//     background: #f8f8f8;
//     font-size: 12px;

//     &:hover {
//       border-color: #15a9e7;
//       color: #15a9e7;
//     }

//     i {
//       font-weight: 900;
//       margin-left: 3px;
//       font-size: 1.4rem;
//     }
//   }
// }
.bg-white-wrapper {
  padding: 10px 0;
}

.product-search-letter {
  position: relative;
  padding-bottom: 10px;
  // height: 46px;
  overflow: hidden;

  a {
    &.search-more {
      position: absolute;
      right: 0;
      top: 13px;
      font-size: 1rem;
    }
  }
  .sultan-box {
    flex: 23;
  }
  .search-filter {
    display: flex;
    & > span {
      display: inline-block;
      text-align: left;
      // background: #f8f8f8;
      // border: 1px solid #dfdfdf;
      color: #999;
      // margin-right: 10px;
      margin-top: 10px;
      font-size: 16px;
      line-height: 1;
      padding: 6px 8px;
      font-weight: bold;
      vertical-align: top;
      flex: 1;
    }
    a {
      display: inline-block;
      text-align: center;
      // background: #f8f8f8;
      // border: 1px solid #dfdfdf;
      color: #999;
      margin-right: 10px;
      margin-top: 10px;
      font-size: 16px;
      line-height: 1;
      padding: 6px 8px;

      &:hover,
      &.selected {
        // background: #15a9e7;
        // color: #fff;
        color: #15a9e7;
        // color: #2EB8D0;
      }
    }
  }
}
.product-search-count {
  border-top: 1px solid #ccc;
  padding: 10px 0;
}
</style>
